<template>
  <div class="p-2 bgCommon">
      <div
        class="d-flex flex-wrap flex-sm-nowrap mt-2 mb-1 align-items-center justify-content-between"
      >
        <!-- Table Top -->

        <div class="d-flex flex-wrap flex-sm-nowrap align-items-center">
          <div>
            <!-- <feather-icon size="16" icon="SearchIcon"></feather-icon> -->
            <span class="title-size text-nowrap">客戶</span>
          </div>
          <!-- <h3 class="font-weight-bolder text-nowrap mb-0">
             <feather-icon size="18" icon="CreditCardIcon" />
            貸款上傳／更改紀錄
          </h3> -->
          <div class="form-col-select ml-2">
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block"
            />
            <feather-icon size="18" icon="ChevronDownIcon" />
          </div>
          <div class="d-flex align-items-center mobile-w100 ml-0 ml-sm-1 mt-1 mt-sm-0">
            <div class="search-primary">
              <feather-icon size="16" icon="SearchIcon" />
            <b-form-input
                v-model="searchQuery"
                class="d-inline-block"
                placeholder="搜尋客戶"
              />
            </div>
          </div>
        </div>
          <div
            class="rd-flex flex-wrap flex-sm-nowrap mt-1 mt-md-0" 
            v-if="ability.can('create', 'client')"
          >
              <b-button
                variant="primary"
                class="mobile-w100 mr-0 mr-sm-1 mt-1 mt-sm-0"
                :to="{ name: 'clients-multi-create' }"
              >
                <span class="text-nowrap">批量新增客戶</span>
              </b-button>
              <b-button
                variant="info"
                class="mobile-w100 mr-0 mr-sm-1 mt-1 mt-sm-0"
                @click="showFilteredClientsModal"
              >
                <span class="text-nowrap">篩選特殊客戶</span>
              </b-button>
            <!-- <div class="col-sm-4">
              <b-button
                variant="primary"
                class="mobile-w100 mt-2 mt-sm-0"
                :to="{ name: 'clients-multi-home-members' }"
              >
                <span class="text-nowrap">批量新增家庭成員</span>
              </b-button>
            </div> -->
            
              <b-button
                variant="primary"
                class="mobile-w100 mt-1 mt-sm-0"
                :to="{ name: 'clients-create' }"
              >
                <span class="text-nowrap">新增客戶</span>
              </b-button>
          </div>
      </div>
    <b-card class="card-statistics p-1 p-sm-0">
      <b-table
        ref="refClientListTable"
        class="position-relative"
        :items="fetchClients"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="未找到匹配的記錄"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: create time -->
        <template #cell(created_at)="data">
            {{ data.item.created_at && getCorrectDateTime(data.item.created_at) }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            class="action-trigger-btn"
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- <b-dropdown-item
            :to="{ name: 'clients-detail', params: { id: data.item.id } }"
            >
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">詳細資料</span>
            </b-dropdown-item> -->

            <b-dropdown-item
              v-if="ability.can('update', 'client')"
              :to="{ name: 'clients-edit', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">修改資料</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
              {{ dataMeta.to }}個記錄</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalClients"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- 篩選特殊客戶 Modal -->
    <b-modal
      id="filtered-clients-modal"
      ref="filteredClientsModal"
      title="篩選特殊條件客戶"
      size="xl"
      hide-footer
    >
      <div v-if="isLoadingFilteredClients" class="text-center">
        <b-spinner label="載入中..."></b-spinner>
        <p class="mt-2">載入中...</p>
      </div>
      <div v-else>
        <div class="mb-3">
          <p class="text-muted">
            篩選條件：沒有貸款記錄、沒有account記錄，但有reject記錄和search記錄的客戶
          </p>
          <p class="font-weight-bold text-primary">
            共找到 {{ filteredClients.length }} 位符合條件的客戶 (按reject記錄數排序)
          </p>
        </div>
        
        <b-table
          v-if="filteredClients.length > 0"
          :items="filteredClients"
          :fields="filteredClientsFields"
          responsive
          striped
        >
          <!-- Column: ID -->
          <template #cell(id)="data">
            {{ data.item.id }}
          </template>

          <!-- Column: ID Number -->
          <template #cell(id_number)="data">
            {{ data.item.id_number }}
          </template>

          <!-- Column: Name -->
          <template #cell(name)="data">
            <div>
              <div v-if="data.item.name_cn">{{ data.item.name_cn }}</div>
              <div v-if="data.item.name_en" class="text-muted small">{{ data.item.name_en }}</div>
              <div v-if="!data.item.name_cn && !data.item.name_en" class="text-muted">--</div>
            </div>
          </template>

          <!-- Column: Gender -->
          <template #cell(gender)="data">
            <span v-if="data.item.gender">{{ data.item.gender }}</span>
            <span v-else class="text-muted">--</span>
          </template>

          <!-- Column: Search Records Count -->
          <template #cell(search_count)="data">
            <b-badge variant="primary">{{ data.item.search_count }}</b-badge>
          </template>

          <!-- Column: Reject Records Count -->
          <template #cell(reject_count)="data">
            <b-badge variant="warning">{{ data.item.reject_count }}</b-badge>
          </template>

          <!-- Column: Created Date -->
          <template #cell(created_at)="data">
            {{ data.item.created_at && getCorrectDateTime(data.item.created_at) }}
          </template>
        </b-table>

        <div v-else class="text-center text-muted p-4">
          <p>沒有找到符合條件的客戶</p>
        </div>

        <div class="text-right mt-3">
          <b-button
            variant="secondary"
            @click="$bvModal.hide('filtered-clients-modal')"
          >
            關閉
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
    
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useClientsList from "./useClientsList";
import clientStoreModule from "../clientStoreModule";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    BSpinner,
    vSelect,
  },
  methods: {
    triggerResetPasswordModal(item) {
      this.clientInfo.id = item.id;
      this.clientInfo.name = item.name;
      this.clientInfo.password = "";
      this.clientInfo.password_confirmation = "";
      this.$bvModal.show("modal-reset-client-password");
    },
    async showFilteredClientsModal() {
      this.isLoadingFilteredClients = true;
      this.$bvModal.show("filtered-clients-modal");
      
      try {
        const response = await this.$http.get('/client/filtered-for-bulk-add');
        this.filteredClients = response.data.clients || [];
      } catch (error) {
        console.error('載入篩選客戶失敗:', error);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "錯誤",
            icon: "AlertTriangleIcon",
            text: "載入篩選客戶失敗",
          },
        });
        this.filteredClients = [];
      } finally {
        this.isLoadingFilteredClients = false;
      }
    },
  },
  data() {
    return {
      clientInfo: { id: 0, password: "", password_confirmation: "" },
      isLoadingFilteredClients: false,
      filteredClients: [],
      filteredClientsFields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'id_number', label: '身份證號碼', sortable: true },
        { key: 'name', label: '姓名', sortable: false },
        { key: 'gender', label: '性別', sortable: false },
        { key: 'search_count', label: 'Search記錄數', sortable: true },
        { key: 'reject_count', label: 'Reject記錄數', sortable: true },
        { key: 'created_at', label: '創建時間', sortable: true },
      ],
    };
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-client";

    // Use toast
    const toast = useToast();

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, clientStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchClients,
      tableColumns,
      perPage,
      currentPage,
      totalClients,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refClientListTable,
      refetchData,
      ability,
    } = useClientsList();

    return {
      // Sidebar
      fetchClients,
      tableColumns,
      perPage,
      currentPage,
      totalClients,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refClientListTable,
      refetchData,
      ability,
      // Toast
      toast,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.search-primary {
  // width: calc(100% - 700px);
  width: calc(100% - 500px);
}
.top-button-list {
  // width: 500px;
  margin: 0;
  .btn {
    width: 150px;
    margin: 0 auto;
    display: block;
  }
}
@media screen and (max-width: 991px) {
  .search-primary {
    width: 100%;
  }
  .top-button-list {
    margin-left: auto;
    margin-right: 20px;
    .btn {
      width: 150px;
      margin: 0 auto;
      display: block;
    }
  }
}

@media screen and (max-width: 768px) {
  .search-primary {
    width: 100%;
  }
}
@media screen and (max-width: 575px) {
  .top-button-list {
    margin: 0;
    width: 100%;
  }
}
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
    